/* eslint-disable import/prefer-default-export */
import {
  HOME,
  MESSAGES,
  ADD_MESSAGE,
  EDIT_MESSAGE,
  PROGRAMS,
  ADD_PROGRAM,
  EDIT_PROGRAM,
} from 'constants/routes';

const breadcrumbsList = [
  { key: MESSAGES, label: 'Inspiration' },
  { key: ADD_MESSAGE, label: 'Inspiration/Add New' },
  { key: EDIT_MESSAGE, label: 'Inspiration/Edit' },
  { key: PROGRAMS, label: 'Program Library' },
  { key: ADD_PROGRAM, label: 'Program Library/Add New Program' },
  { key: EDIT_PROGRAM, label: 'Program Library/Edit Program' },
];

export const getBreadcrumbLabel = (path: string): string => {
  const currentPath = path === HOME ? MESSAGES : path;
  const breadcrumb = breadcrumbsList.filter((item) => item.key === currentPath);
  return breadcrumb.length > 0 ? breadcrumb[0].label : '';
};
